import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import {
  FPDetails,
  LandingHttpResponse,
  PyResponse,
  SignInDetails,
  SignInPayload,
  SignInResponse,
  SignUpDetails,
  SignUpResponse,
} from '../store/state/landing-page.state';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private baseUrl: string = environment.baseUrl;
  constructor(private httpClient: HttpClient) {}

  signIn(signInDetails: SignInDetails): Observable<SignInResponse> {
    const payload: SignInPayload = {
      userId: signInDetails.email,
      password: signInDetails.password,
    };
    return this.httpClient.post<SignInResponse>(
      `${this.baseUrl}/cm-services/api/v1/login-service/users/sign-in`,
      payload,
    );
  }

  signUp(signUpDetails: SignUpDetails): Observable<SignUpResponse> {
    return this.httpClient.post<SignUpResponse>(
      `${this.baseUrl}/cm-services/api/v1/login-service/users/sign-up`,
      signUpDetails,
    );
  }

  requestOTP(emailId: string): Observable<LandingHttpResponse> {
    return this.httpClient.post<LandingHttpResponse>(
      `${this.baseUrl}/cm-services/api/v1/login-service/reset/request-otp`,
      { emailId },
    );
  }

  resetPassword(fpDetails: FPDetails): Observable<PyResponse> {
    return this.httpClient.post<PyResponse>(
      `${this.baseUrl}/cm-services/api/v1/login-service/reset/change-password`,
      fpDetails,
    );
  }
}
